module.exports = __webpack_public_path__ + "media/images/athletes/1345-38743e2d3fdfe84e6b6b5a6e3737eef7.png";